import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  isAuthenticated = false;
  userProfile: any = null;

  constructor(public auth: AuthService) {}

  ngOnInit(): void {
    this.auth.isAuthenticated().subscribe(
      isAuthenticated => {
        this.isAuthenticated = isAuthenticated;
        if (isAuthenticated) {
          this.loadUserProfile();
        }
      }
    );
  }

  loadUserProfile(): void {
    this.auth.getUserProfile().subscribe(
      profile => {
        this.userProfile = profile;
      }
    );
  }

  login(): void {
    this.auth.login();
  }

  logout(): void {
    this.auth.logout();
  }
}
